module.exports = __webpack_public_path__ + "vue/img/infobox.7b4cf1c6.svg";